<template>
    <div class="navbar navbar-expand-md navbar-dark border-transparent">
        <div class="navbar-brand wmin-0 mr-5">
            <router-link :to="{name: 'Dashboard'}" class="d-inline-block">
                <img src="../../assets/images/login-logo.png">
            </router-link>
        </div>

        <div class="d-md-none">
            <button @click="showUserMenuOnMobile = !showUserMenuOnMobile" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
                <i class="icon-tree5"></i>
            </button>
        </div>

        <div :class="{'show': showUserMenuOnMobile}" class="collapse navbar-collapse" id="navbar-mobile">

            <ul class="navbar-nav ml-auto">
                <li v-if="user" class="nav-item dropdown dropdown-user">
                    <div>
                        <b-nav-item-dropdown variant="link" toggle-class="d-flex align-items-center user-menu" right>
                            <template slot="button-content">
                                <Avatar :name="user.name" class="mr-2"/>
                                <span class="text-white">{{user.name}}</span>
                            </template>

                            <b-dropdown-item :to="{name: 'PersonalData'}"><i class="icon-user"></i> {{$t('context_menu.user_profile')}}</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'Logout'}"><i class="icon-switch2"></i> {{$t('context_menu.log_out')}}</b-dropdown-item>
                        </b-nav-item-dropdown>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

    import Avatar from '../Utilities/Avatar';
    import {mapGetters} from "vuex";
    export default {
        name: "TopBar",
        components: {Avatar},
        data() {
            return {
                showUserMenuOnMobile: false
            }
        },

        computed: {
            ...mapGetters('Auth', ['user'])
        },

        methods: {
            logout() {
                this.$store.dispatch('Auth/logout');
            }
        }
    }
</script>

<style scoped>

</style>